<!-- eslint-disable -->
<template lang="pug">
    .items
        .list(v-for='list in lists')
            drop.drop.letter__box(
                v-for='(item, itemIndex) in list',
                :key='item + itemIndex',
                @drop='handleDrop(list, itemIndex, ...arguments)'
            )
                drag.drag(:transfer-data='{ item: item, list: list, itemIndex: itemIndex}')
                    | {{ item }}
        cs-button.button.answer-button(@click='handleAnswer')
            | {{ $i18n.t('common.common_button_collect') }}
</template>

<script>
    /*eslint-disable*/
  import { Drag, Drop } from 'vue-drag-drop';

  export default {
      data () {
          return {
              lists: [
                  ['О', 'М', 'И', 'Р', 'Р', 'А', 'И', 'Т'],
                  ['', '', '', '','', '', '', ''],
              ],
              name: "мориарти"
          }
      },
      methods: {
          handleDrop(toList, itemIndex, data) {
              const fromList = data.list;
              if (fromList && itemIndex >= 0) {
                  fromList.splice(data.itemIndex, 1, toList[itemIndex]);
                  toList.splice(itemIndex, 1, data.item)
              }
          },
          handleAnswer() {
              if (this.lists[1].join('').toLowerCase() === this.name){
                  this.$emit('rightAnswer');
              } else {
                  this.name.split('').forEach((value, index) => {
                      if (this.lists[1][index] !== value.toUpperCase() && this.lists[1][index] !== '') {
                          this.$set(this.lists[0], this.lists[0].indexOf(''), this.lists[1][index])
                          this.$set(this.lists[1], index, '')
                      }
                  });
              }
          }
      },
      components: {
          Drag,
          Drop
      },
  }
</script>

<style scoped lang="scss">
    $tablet: 769px !default

    .items {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        left: 10%;
        top: 40%;
        @media screen and (max-width: $tablet - 1px) {
            right: 0;
            top: 10%;
        }
    }

    .list {
        margin: 10px;
    }

    .answer-button {
        width: 50%;
    }

    .letter__box {
        background-color: #FFFFFF;
        cursor: pointer;
        font-size: 30px;
        margin-right: 10px;
        padding: 10px;
        text-align: center;
        min-width: 48px;
        border: solid 1px black;
        border-radius: 5px;
        @media screen and (max-width: $tablet - 1px) {
            font-size: 25px;
            padding: 5px;
            text-align: center;
            min-width: 40px;
        }
        &:last-child {
            margin-right: 0;
        }
    }

    .drag, .drop {
        display: inline-block;
    }
</style>
